angular.module("app").controller("CasinoGamesListPageController", [
    '$scope',
    'pagination',
    '$timeout',
    'casinoGameService',
    'errorHandler',
    '$state',
    'preloadedData',
    'preloadedCategories',
    'preloadedSubCategories',
    'logger',
    'preloadedProviders',
    function ($scope, pagination, $timeout, casinoGameService, errorHandler, $state, preloadedData, preloadedCategories, preloadedSubCategories, logger, preloadedProviders) {
        var pendingListRequest;

        $scope.games = angular.copy(preloadedData.skinGames);
        $scope.tabOptions = {};
        $scope.filterOptions = {
            status: 'active'
        };
        $scope.multiSelect = {
            selectedCategories: [],
            selectedSubCategories: [],
            selectedProviders: [],
            categories: angular.copy(preloadedCategories),
            subCategories: angular.copy(preloadedSubCategories),
            providers: angular.copy(preloadedProviders)
        };

        $scope.pagination = pagination.init(function (resetPage) {
            !!pendingListRequest && $timeout.cancel(pendingListRequest);
            pendingListRequest = $timeout(function () {
                var requestData = getFiltersValues();
                requestData.current_page =  $scope.pagination.page;
                resetPage && (requestData.current_page = 1);
                updateList(requestData)
            }, 300);
        }, preloadedData.total_count);

        $scope.getDateTime = function (dateString) {
            return new Date(dateString).getTime()
        };

        $scope.editGame = function (game) {
            $state.go("main.casinoGames.edit", {gameId: game.gameSkinId})
        };

        $scope.onFilterSelect
            = $scope.onFilterDeselect
            = $scope.onFilterSelectAll
            = $scope.onFilterDeselectAll
            = function () {
            return $scope.pagination.changePage()
        };

        $scope.toggleGameActivity = function (gameData, action) {
            var requestData = {
                skinGame: {
                    id: gameData.gameSkinId,
                    active: action
                }
            };
            casinoGameService.editSkinGame(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.filterOptions.status !== 'all' && spliceFromList(gameData);
                        logger.logSuccess(action ? "global.activated" : "global.disabled");
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                }
            )
        };

        function spliceFromList(game) {
            var index = $scope.games.indexOf(game);
            if (index != -1) {
                $scope.games.splice(index, 1);
            }
        }

        function updateList(requestOptions) {
            casinoGameService.getSkinGames(requestOptions).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.games = angular.copy(response.skinGames)
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }


        $scope.allowUpdate = function (options) {
            if (options && options.autoUpdate) {
                reorder();
            } else if (!!options) {
                $scope.tabOptions.reordered = true
            }
        };

        function reorder () {
            if (typeof $scope.games === "object" && $scope.games.length) {
                var list = [];
                $scope.games.forEach(function (item) {
                    list.push(item.gameSkinId);
                });

                casinoGameService.changeOrderSkinGames({order: list}).then(
                    function (response) {
                        if (response.status === "ok") {
                            logger.logSuccess("global.updated")
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                )
            }
        }


        function getFiltersValues() {
            var categories = [],
                subCategories = [],
                providers = [],
                filtersData = {},
                isActive = (($scope.filterOptions.status === 'active') || (($scope.filterOptions.status === 'all') ? undefined : false));

            $scope.multiSelect.selectedCategories.forEach(function (value) {
                categories.push(value.id)
            });

            $scope.multiSelect.selectedSubCategories.forEach(function (value) {
                subCategories.push(value.id)
            });

            $scope.multiSelect.selectedProviders.forEach(function (value) {
                providers.push(value.id)
            });

            filtersData.current_page = $scope.pagination.page;
            filtersData.limit = $scope.pagination.limit;
            filtersData.categories = categories;
            filtersData.current_page = subCategories;
            filtersData.providers = providers;

            angular.isDefined(isActive) && (filtersData.active = isActive);
            return filtersData
        }
    }
]);